import { withChildren } from '@builder.io/react';
import { COLOR_KEYS } from '../../../constants';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { SectionName, withTracking } from '../../../observability';
import { DEFAULT_VALUES } from './fixtures';
import { VideoSection } from './VideoSection';

export default createBuilderModule(
  withChildren(
    withTracking(VideoSection, {
      as: 'section',
      sectionName: SectionName.VideoSection,
    }),
  ),
  {
    name: 'VideoSection',
    image: 'https://cdn.zappy.app/e994545429dd171ac93ccd78217bbf37.png',
    inputs: [
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.moss,
          COLOR_KEYS.neutral800,
          COLOR_KEYS.night,
          COLOR_KEYS.zapier,
        ],
        required: true,
        defaultValue: DEFAULT_VALUES.backgroundColor,
      },
      {
        name: 'heading',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.heading,
      },
      {
        name: 'description',
        type: 'richText',
      },
      {
        name: 'wistiaId',
        type: 'string',
      },
    ],
  },
);
